module.exports = __webpack_public_path__ + "static/img/home_img_n&p@2x.07683f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/home_img_n&p@2x.png
// module id = 623B
// module chunks = 0